import { CaeBridge, CaeItem, CaeRail } from '@project/cae/cae-data.service';

export class CaeImportError {
  constructor(
    public rail: string,
    public railId: string,
    public item: string,
    public itemId: string,
    public itemNo: string,
    public messageKey: string,
    public messageParams: string[],
  ) {
  }
}

export class CaeImportErrorCollector {
  private _errors: CaeImportError[] = [];
  public get errors(): readonly CaeImportError[] {
    return this._errors;
  }

  private _caeRail: CaeRail | undefined;

  public processRail(caeRail: CaeRail) {
    this._caeRail = caeRail;
  }

  public addErrorForItem(caeItem: CaeItem, messageKey: string, messageParams: string[] = []): void {
    const error = this.createImportErrorForItem(caeItem, messageKey, messageParams);
    this._errors.push(error);
  }

  public addErrorForBridge(caeBridge: CaeBridge, messageKey: string, messageParams: string[] = []) {
    const error = new CaeImportError(
      this._caeRail?.name || '',
      this._caeRail?.id || '',
      '',
      caeBridge.id,
      '',
      messageKey,
      messageParams,
    );
    this._errors.push(error);
  }

  public addError(caeImportError: CaeImportError): void {
    this._errors.push(caeImportError);
  }

  public addErrorMessage(messageKey: string, messageParams: string[] = []): void {
    const error = new CaeImportError(
      this._caeRail?.name || '',
      this._caeRail?.id || '',
      '',
      '',
      '',
      messageKey,
      messageParams,
    );
    this._errors.push(error);
  }

  public createImportErrorForItem(caeItem: CaeItem, messageKey: string, messageParams: string[] = []): CaeImportError {
    return new CaeImportError(
      this._caeRail?.name || '',
      this._caeRail?.id || '',
      caeItem.name,
      caeItem.id,
      caeItem.articleNo,
      messageKey,
      messageParams,
    );
  }

  public clear() {
    this._errors = [];
  }
}
